import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  from
} from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { onError } from '@apollo/client/link/error';
import Cookies from 'js-cookie';
import userStore from 'stores/user.store';
import { noAuthPaths } from 'config.json';

const baseGraphqlUrl = `${process.env.REACT_APP_API_URL}/graphql`;

// Store the original fetch
const originalFetch = typeof fetch !== 'undefined' ? fetch : null;

// /**
//  * Custom fetch that preserves empty strings in GraphQL mutations
//  * Only intercepts requests to the GraphQL endpoint
//  *
//  * This intercepts the fetch call and modifies the JSON body to ensure
//  * empty strings are preserved instead of being converted to null.
//  */
// const createGraphQLFetch = () => {
//   if (!originalFetch) return null;
//
//   return (uri, options) => {
//     // Only intercept GraphQL requests
//     const isGraphQLRequest = typeof uri === 'string' && uri.includes('/graphql');
//
//     if (isGraphQLRequest) {
//       // Only process JSON requests (not FormData)
//       if (options?.body && typeof options.body === 'string') {
//         const contentType = options.headers?.['Content-Type'] || options.headers?.['content-type'] || '';
//
//         if (contentType.includes('application/json')) {
//           try {
//             const body = JSON.parse(options.body);
//
//             /**
//              * Recursively restore empty strings from null values
//              */
//             const restoreEmptyStrings = (obj, path = '') => {
//               if (obj === null) {
//                 // If we're in a mutation with phase input and this is a string field, restore to ''
//                 if (body.operationName?.includes('CreatePhase') && path.includes('phase.')) {
//                   const fieldName = path.split('.').pop();
//                   const stringFields = ['description', 'coverImageUrl', 'coverVideoUrl', 'thumbnail', 'notes', 'name'];
//                   if (stringFields.includes(fieldName)) {
//                     return '';
//                   }
//                 }
//                 return obj;
//               }
//
//               if (typeof obj === 'string' || obj === null || obj === undefined) {
//                 return obj;
//               }
//
//               if (Array.isArray(obj)) {
//                 return obj.map((item, index) => restoreEmptyStrings(item, `${path}[${index}]`));
//               }
//
//               if (typeof obj === 'object') {
//                 const result = {};
//                 for (const key in obj) {
//                   if (Object.prototype.hasOwnProperty.call(obj, key)) {
//                     const newPath = path ? `${path}.${key}` : key;
//                     result[key] = restoreEmptyStrings(obj[key], newPath);
//                   }
//                 }
//                 return result;
//               }
//
//               return obj;
//             };
//
//             const processed = restoreEmptyStrings(body);
//             options.body = JSON.stringify(processed);
//           } catch (e) {
//             // Silently continue if parsing fails
//           }
//         }
//       }
//     }
//
//     return originalFetch(uri, options);
//   };
// };

const authMiddleWare = new ApolloLink((operation, forward) => {
  const token = Cookies.get('XSRF-TOKEN');
  operation.setContext({
    headers: {
      'Access-Control-Allow-Credentials': true,
      'X-XSRF-TOKEN': token
    }
  });
  return forward(operation);
});

// /**
//  * Apollo Link that preserves empty strings in CreatePhase mutations
//  * This processes variables BEFORE they are serialized by Apollo Client
//  */
// const preserveEmptyStringsLink = new ApolloLink((operation, forward) => {
//   // Only process CreatePhase mutations
//   if (operation.operationName === 'CreatePhase' && operation.variables?.phase) {
//     const stringFields = ['description', 'coverImageUrl', 'coverVideoUrl', 'thumbnail', 'notes', 'name'];
//
//     // Ensure empty strings are preserved (not null/undefined)
//     stringFields.forEach(field => {
//       if (operation.variables.phase[field] === null || operation.variables.phase[field] === undefined) {
//         operation.variables.phase[field] = '';
//       } else if (typeof operation.variables.phase[field] === 'string') {
//         const value = operation.variables.phase[field];
//         if (value === 'null' || value === 'undefined') {
//           operation.variables.phase[field] = '';
//         }
//       }
//     });
//   }
//
//   return forward(operation);
// });

// Create custom fetch for GraphQL requests (commented out - using originalFetch)
// const graphQLFetch = createGraphQLFetch();

const uploadLink = createUploadLink({
  uri: baseGraphqlUrl,
  credentials: 'include',
  fetch: originalFetch
});

const logoutLink = onError(({ networkError }) => {
  if (networkError && [401, 419].includes(networkError.statusCode)) {
    if (!noAuthPaths.includes(window.location.pathname)) {
      userStore.setRedirectToLogin(true);
      userStore.setIsAuthenticated(false);
    }
    apolloClient.resetStore();
  }
});


const apolloClient = new ApolloClient({
  link: from([
    authMiddleWare,
    // preserveEmptyStringsLink, // Process variables before serialization (commented out)
    logoutLink,
    uploadLink
  ]),
  cache: new InMemoryCache(),
  name: 'barwis-web-app',
  queryDeduplication: false,
  defaultOptions: {
    query: {
      errorPolicy: 'all'
    },
    mutate: {
      errorPolicy: 'all'
    }
  },
  connectToDevTools: true
});

export default apolloClient;
